module.exports = __webpack_public_path__ + "img/INK.e47153ed.svg";